export const PRICING_SERVICE_ENDPOINT = {
  CREATE_PRIVATE_PLAN: '/manage/private-policy',
  UPDATE_PRIVATE_PLAN: '/manage/update/private-policy',
  GET_PRICING_DETAILS: '/policies/pricingPolicies',
  CURRENCY: '/currency'
};
